import { createContext } from 'react';

import { OSPatch } from '@totem/components/devices/os-patches/types';

interface Context {
  deviceId: string;
  loading: boolean;
  data: OSPatch[];
  action: string;
  actionItem: OSPatch;
  onAction?: (action: string, item: OSPatch) => void;
}

export default createContext<Context>({
  deviceId: '',
  loading: false,
  data: null,
  action: '',
  actionItem: null,
  onAction: () => {},
});
